import React from 'react';
import ReactDOM from 'react-dom/client';

import './locale/setup';

import './styles/tw.css';
import './styles/global.css';

import { App } from './App';
import { env } from 'config/env';
import { disableReactDevTools } from 'utils/reactDevTools';

if (env.stage === 'prd') disableReactDevTools();

ReactDOM.createRoot(document.getElementById('app-wrapper')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
